import { CustomFieldDefinition } from "gen/clients";

const CUSTOM_FIELD_TYPE_LABELS: Record<CustomFieldDefinition.type, string> = {
  [CustomFieldDefinition.type.INPUT_TEXT]: "Input text",
  [CustomFieldDefinition.type.LISTONLY]: "Select list",
  [CustomFieldDefinition.type.LIST]: "Select list with free text",
  [CustomFieldDefinition.type.SELECT_MANY_LIST]: "Select-many list",
  [CustomFieldDefinition.type.DATE]: "Date",
  [CustomFieldDefinition.type.TEXT_AREA]: "Text area",
  [CustomFieldDefinition.type.CHECKBOX]: "Checkbox",
  [CustomFieldDefinition.type.PERSON_INFO]: "Person info (First name, Last name, Email)"
};

export class CustomFieldUtils {
  /**
   * Retrieves the label associated with a specific custom field type.
   *
   * @param {CustomFieldDefinition.type} type - The custom field type for which the label is to be retrieved.
   * @return {string} The label corresponding to the provided custom field type.
   */
  public static getLabelForType(type: CustomFieldDefinition.type): string {
    return CUSTOM_FIELD_TYPE_LABELS[type];
  }

  /**
   * Determines whether a custom field type requires at least one option to be defined.
   *
   * @param {CustomFieldDefinition.type} type - The custom field type to check.
   * @return {boolean} True if the type requires options, otherwise false.
   */
  public static requiresOptions(type: CustomFieldDefinition.type): boolean {
    return [
      CustomFieldDefinition.type.LISTONLY,
      CustomFieldDefinition.type.LIST,
      CustomFieldDefinition.type.SELECT_MANY_LIST
    ].includes(type);
  }
}
